webpackJsonp([12],{

/***/ "2P/j":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" enable-background=\"new 0 0 12 14\"><path d=\"m11.5 2.4l-1.3-1.1-1 1.1 1.4 1.1.9-1.1\"/><path d=\"m6.8 2v-.5h.5v-1.5h-2.6v1.5h.5v.5c-2.9.4-5.2 2.9-5.2 6 0 3.3 2.7 6 6 6s6-2.7 6-6c0-3-2.3-5.6-5.2-6m-.8 10.5c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5 4.5 2 4.5 4.5-2 4.5-4.5 4.5\"/><path d=\"m6.2 8.9h-.5c-.1 0-.2-.1-.2-.2v-3.5c0-.1.1-.2.2-.2h.5c.1 0 .2.1.2.2v3.5c0 .1-.1.2-.2.2\"/></svg>\n"

/***/ }),

/***/ "MRGx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icons_icon_stopwatch_svg__ = __webpack_require__("2P/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icons_icon_stopwatch_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_icons_icon_stopwatch_svg__);



__webpack_require__("I8f0");

(function () {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('time-tracking-collapsed-state', {
    name: 'time-tracking-collapsed-state',
    props: ['showComparisonState', 'showSpentOnlyState', 'showEstimateOnlyState', 'showNoTimeTrackingState', 'timeSpentHumanReadable', 'timeEstimateHumanReadable'],
    methods: {
      abbreviateTime: function abbreviateTime(timeStr) {
        return gl.utils.prettyTime.abbreviateTime(timeStr);
      }
    },
    template: '\n      <div class=\'sidebar-collapsed-icon\'>\n        ' + __WEBPACK_IMPORTED_MODULE_1_icons_icon_stopwatch_svg___default.a + '\n        <div class=\'time-tracking-collapsed-summary\'>\n          <div class=\'compare\' v-if=\'showComparisonState\'>\n            <span>{{ abbreviateTime(timeSpentHumanReadable) }} / {{ abbreviateTime(timeEstimateHumanReadable) }}</span>\n          </div>\n          <div class=\'estimate-only\' v-if=\'showEstimateOnlyState\'>\n            <span class=\'bold\'>-- / {{ abbreviateTime(timeEstimateHumanReadable) }}</span>\n          </div>\n          <div class=\'spend-only\' v-if=\'showSpentOnlyState\'>\n            <span class=\'bold\'>{{ abbreviateTime(timeSpentHumanReadable) }} / --</span>\n          </div>\n          <div class=\'no-tracking\' v-if=\'showNoTimeTrackingState\'>\n            <span class=\'no-value\'>None</span>\n          </div>\n        </div>\n      </div>\n      '
  });
})();

/***/ }),

/***/ "P0QM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");


(function () {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('time-tracking-spent-only-pane', {
    name: 'time-tracking-spent-only-pane',
    props: ['timeSpentHumanReadable'],
    template: '\n      <div class=\'time-tracking-spend-only-pane\'>\n        <span class=\'bold\'>Spent:</span>\n        {{ timeSpentHumanReadable }}\n      </div>\n    '
  });
})();

/***/ }),

/***/ "QeeU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("7UJR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_resource__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




__webpack_require__("sEe6");
__webpack_require__("EQHa");
__webpack_require__("OX5X");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource___default.a);

(function () {
  /* This Vue instance represents what will become the parent instance for the
    * sidebar. It will be responsible for managing `issuable` state and propagating
    * changes to sidebar components. We will want to create a separate service to
    * interface with the server at that point.
   */

  var IssuableTimeTracking = function () {
    function IssuableTimeTracking(issuableJSON) {
      _classCallCheck(this, IssuableTimeTracking);

      var parsedIssuable = JSON.parse(issuableJSON);
      return this.initComponent(parsedIssuable);
    }

    _createClass(IssuableTimeTracking, [{
      key: 'initComponent',
      value: function initComponent(parsedIssuable) {
        this.parentInstance = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
          el: '#issuable-time-tracker',
          data: {
            issuable: parsedIssuable
          },
          methods: {
            fetchIssuable: function fetchIssuable() {
              return gl.IssuableResource.get.call(gl.IssuableResource, {
                type: 'GET',
                url: gl.IssuableResource.endpoint
              });
            },
            updateState: function updateState(data) {
              this.issuable = data;
            },
            subscribeToUpdates: function subscribeToUpdates() {
              var _this = this;

              gl.IssuableResource.subscribe(function (data) {
                return _this.updateState(data);
              });
            },
            listenForSlashCommands: function listenForSlashCommands() {
              var _this2 = this;

              $(document).on('ajax:success', '.gfm-form', function (e, data) {
                var subscribedCommands = ['spend_time', 'time_estimate'];
                var changedCommands = data.commands_changes ? Object.keys(data.commands_changes) : [];
                if (changedCommands && _.intersection(subscribedCommands, changedCommands).length) {
                  _this2.fetchIssuable();
                }
              });
            }
          },
          created: function created() {
            this.fetchIssuable();
          },
          mounted: function mounted() {
            this.subscribeToUpdates();
            this.listenForSlashCommands();
          }
        });
      }
    }]);

    return IssuableTimeTracking;
  }();

  gl.IssuableTimeTracking = IssuableTimeTracking;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "aCc3":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("QeeU");

/***/ }),

/***/ "dwzv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");


(function () {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('time-tracking-no-tracking-pane', {
    name: 'time-tracking-no-tracking-pane',
    template: '\n      <div class=\'time-tracking-no-tracking-pane\'>\n        <span class=\'no-value\'>No estimate or time spent</span>\n      </div>\n    '
  });
})();

/***/ }),

/***/ "g393":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");


(function () {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('time-tracking-help-state', {
    name: 'time-tracking-help-state',
    props: ['docsUrl'],
    template: '\n      <div class=\'time-tracking-help-state\'>\n        <div class=\'time-tracking-info\'>\n          <h4>Track time with slash commands</h4>\n          <p>Slash commands can be used in the issues description and comment boxes.</p>\n          <p>\n            <code>/estimate</code>\n            will update the estimated time with the latest command.\n          </p>\n          <p>\n            <code>/spend</code>\n            will update the sum of the time spent.\n          </p>\n          <a class=\'btn btn-default learn-more-button\' :href=\'docsUrl\'>Learn more</a>\n        </div>\n      </div>\n    '
  });
})();

/***/ }),

/***/ "jOPE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");


__webpack_require__("I8f0");

(function () {
  var prettyTime = gl.utils.prettyTime;

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('time-tracking-comparison-pane', {
    name: 'time-tracking-comparison-pane',
    props: ['timeSpent', 'timeEstimate', 'timeSpentHumanReadable', 'timeEstimateHumanReadable'],
    computed: {
      parsedRemaining: function parsedRemaining() {
        var diffSeconds = this.timeEstimate - this.timeSpent;
        return prettyTime.parseSeconds(diffSeconds);
      },
      timeRemainingHumanReadable: function timeRemainingHumanReadable() {
        return prettyTime.stringifyTime(this.parsedRemaining);
      },
      timeRemainingTooltip: function timeRemainingTooltip() {
        var prefix = this.timeRemainingMinutes < 0 ? 'Over by' : 'Time remaining:';
        return prefix + ' ' + this.timeRemainingHumanReadable;
      },

      /* Diff values for comparison meter */
      timeRemainingMinutes: function timeRemainingMinutes() {
        return this.timeEstimate - this.timeSpent;
      },
      timeRemainingPercent: function timeRemainingPercent() {
        return Math.floor(this.timeSpent / this.timeEstimate * 100) + '%';
      },
      timeRemainingStatusClass: function timeRemainingStatusClass() {
        return this.timeEstimate >= this.timeSpent ? 'within_estimate' : 'over_estimate';
      },

      /* Parsed time values */
      parsedEstimate: function parsedEstimate() {
        return prettyTime.parseSeconds(this.timeEstimate);
      },
      parsedSpent: function parsedSpent() {
        return prettyTime.parseSeconds(this.timeSpent);
      }
    },
    template: '\n      <div class=\'time-tracking-comparison-pane\'>\n        <div class=\'compare-meter\' data-toggle=\'tooltip\' data-placement=\'top\' role=\'timeRemainingDisplay\'\n          :aria-valuenow=\'timeRemainingTooltip\'\n          :title=\'timeRemainingTooltip\'\n          :data-original-title=\'timeRemainingTooltip\'\n          :class=\'timeRemainingStatusClass\'>\n          <div class=\'meter-container\' role=\'timeSpentPercent\' :aria-valuenow=\'timeRemainingPercent\'>\n            <div :style=\'{ width: timeRemainingPercent }\' class=\'meter-fill\'></div>\n          </div>\n          <div class=\'compare-display-container\'>\n            <div class=\'compare-display pull-left\'>\n              <span class=\'compare-label\'>Spent</span>\n              <span class=\'compare-value spent\'>{{ timeSpentHumanReadable }}</span>\n            </div>\n            <div class=\'compare-display estimated pull-right\'>\n              <span class=\'compare-label\'>Est</span>\n              <span class=\'compare-value\'>{{ timeEstimateHumanReadable }}</span>\n            </div>\n          </div>\n        </div>\n      </div>\n    '
  });
})();

/***/ }),

/***/ "juMy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");


(function () {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('time-tracking-estimate-only-pane', {
    name: 'time-tracking-estimate-only-pane',
    props: ['timeEstimateHumanReadable'],
    template: '\n      <div class=\'time-tracking-estimate-only-pane\'>\n        <span class=\'bold\'>Estimated:</span>\n        {{ timeEstimateHumanReadable }}\n      </div>\n    '
  });
})();

/***/ }),

/***/ "sEe6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");


__webpack_require__("g393");
__webpack_require__("MRGx");
__webpack_require__("P0QM");
__webpack_require__("dwzv");
__webpack_require__("juMy");
__webpack_require__("jOPE");

(function () {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('issuable-time-tracker', {
    name: 'issuable-time-tracker',
    props: ['time_estimate', 'time_spent', 'human_time_estimate', 'human_time_spent', 'docsUrl'],
    data: function data() {
      return {
        showHelp: false
      };
    },

    computed: {
      timeSpent: function timeSpent() {
        return this.time_spent;
      },
      timeEstimate: function timeEstimate() {
        return this.time_estimate;
      },
      timeEstimateHumanReadable: function timeEstimateHumanReadable() {
        return this.human_time_estimate;
      },
      timeSpentHumanReadable: function timeSpentHumanReadable() {
        return this.human_time_spent;
      },
      hasTimeSpent: function hasTimeSpent() {
        return !!this.timeSpent;
      },
      hasTimeEstimate: function hasTimeEstimate() {
        return !!this.timeEstimate;
      },
      showComparisonState: function showComparisonState() {
        return this.hasTimeEstimate && this.hasTimeSpent;
      },
      showEstimateOnlyState: function showEstimateOnlyState() {
        return this.hasTimeEstimate && !this.hasTimeSpent;
      },
      showSpentOnlyState: function showSpentOnlyState() {
        return this.hasTimeSpent && !this.hasTimeEstimate;
      },
      showNoTimeTrackingState: function showNoTimeTrackingState() {
        return !this.hasTimeEstimate && !this.hasTimeSpent;
      },
      showHelpState: function showHelpState() {
        return !!this.showHelp;
      }
    },
    methods: {
      toggleHelpState: function toggleHelpState(show) {
        this.showHelp = show;
      }
    },
    template: '\n      <div class=\'time_tracker time-tracking-component-wrap\' v-cloak>\n        <time-tracking-collapsed-state\n          :show-comparison-state=\'showComparisonState\'\n          :show-help-state=\'showHelpState\'\n          :show-spent-only-state=\'showSpentOnlyState\'\n          :show-estimate-only-state=\'showEstimateOnlyState\'\n          :time-spent-human-readable=\'timeSpentHumanReadable\'\n          :time-estimate-human-readable=\'timeEstimateHumanReadable\'>\n        </time-tracking-collapsed-state>\n        <div class=\'title hide-collapsed\'>\n          Time tracking\n          <div class=\'help-button pull-right\'\n            v-if=\'!showHelpState\'\n            @click=\'toggleHelpState(true)\'>\n            <i class=\'fa fa-question-circle\' aria-hidden=\'true\'></i>\n          </div>\n          <div class=\'close-help-button pull-right\'\n            v-if=\'showHelpState\'\n            @click=\'toggleHelpState(false)\'>\n            <i class=\'fa fa-close\' aria-hidden=\'true\'></i>\n          </div>\n        </div>\n        <div class=\'time-tracking-content hide-collapsed\'>\n          <time-tracking-estimate-only-pane\n            v-if=\'showEstimateOnlyState\'\n            :time-estimate-human-readable=\'timeEstimateHumanReadable\'>\n          </time-tracking-estimate-only-pane>\n          <time-tracking-spent-only-pane\n            v-if=\'showSpentOnlyState\'\n            :time-spent-human-readable=\'timeSpentHumanReadable\'>\n          </time-tracking-spent-only-pane>\n          <time-tracking-no-tracking-pane\n            v-if=\'showNoTimeTrackingState\'>\n          </time-tracking-no-tracking-pane>\n          <time-tracking-comparison-pane\n            v-if=\'showComparisonState\'\n            :time-estimate=\'timeEstimate\'\n            :time-spent=\'timeSpent\'\n            :time-spent-human-readable=\'timeSpentHumanReadable\'\n            :time-estimate-human-readable=\'timeEstimateHumanReadable\'>\n          </time-tracking-comparison-pane>\n          <transition name=\'help-state-toggle\'>\n            <time-tracking-help-state\n              v-if=\'showHelpState\'\n              :docs-url=\'docsUrl\'>\n            </time-tracking-help-state>\n          </transition>\n        </div>\n      </div>\n    '
  });
})();

/***/ })

},["aCc3"]);


// WEBPACK FOOTER //
// issuable.5b6c9697ac3a08e4921b.bundle.js